import { Component } from "react";
import { withRouter } from "../../../withRouter";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import axios from "axios";
import $ from "jquery";
import Select from "react-select";
import { validated } from "react-custom-validation";
import { GET_FORMPOST, GET_DETAILDATA } from "../../../actions";
import { apiUrl, clientheaderconfig } from "../../Helpers/Config";
import { showLoader, hideLoader, showAlert, isEmpty } from "../../Helpers/SettingHelper";
import PageLoader from "../../Helpers/PageLoader";
import Header from "../Layout/Header";
import Topmenu from "../Layout/Topmenu";
import Footer from "../Layout/Footer";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../../ui/tabs";
import { Save, Plus, Trash2, RotateCcw, BarChart3, Activity } from "lucide-react";
import Analytics from "./components/Analytics";
import ProbabilityAnalytics from "./components/ProbabilityAnalytics";
const module = "company";
const moduleName = "Spin Wheel Prize  Settings";
const modulePath = "/clientpanel/spinwheel";
class Form extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageloading: false,
      clientdata: {
        product_name: "test",
        action: "add",
      },
      loading: true,
      formpost: [],
      companyspinwheelEarnType: "",
      companyBonusType: "",
      companySpineWheelEarnPercentage: "",
      companySpineWheelClaimCount: "",
      companyspinwheelVoucher: [],
      totalProbability: 0,
      error_msg: "",
      productList: [],
      productListOptions: [],
      companyDetail: [],
    };
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    this.loadproductList();
    var params = {
      url: apiUrl + module + "/getCompanySettings",
      type: "client",
    };
    this.setState({ pageloading: true });
    this.props.getDetailData(params);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.state.formpost !== nextProps.formpost && this.props.formpost !== nextProps.formpost) {
      if (nextProps.formpost.length > 0) {
        hideLoader("submit_frm", "class");
        var errMsg = nextProps.formpost[0]?.message || "";
        if (nextProps.formpost[0].status === "ok") {
          showAlert("Success", "Spin Wheel settings updated successfully", "success", "No");
          setTimeout(() => {
            this.props.navigate(modulePath);
          }, 1000);
        } else {
          showAlert("Error", errMsg, "error", "No");
        }
      }
    }
    if (this.state.companyDetail !== nextProps.detaildata) {
      this.setState({ companyDetail: nextProps.detaildata }, () => {
        var result = nextProps.detaildata[0].result;
        const companyspinwheelVoucher = result?.companyspinwheelVoucher ?? "";
        const companySpineWheelEarnPercentage = result?.companySpineWheelEarnPercentage ?? "";
        const companySpineWheelClaimCount = result?.companySpineWheelClaimCount ?? "";
        let totalProbability = 0;
        let companyspinwheelVoucher_ =
          companyspinwheelVoucher !== "" && companyspinwheelVoucher !== null
            ? JSON.parse(companyspinwheelVoucher)
            : [
                {
                  voucherID: "",
                  voucherCustomName: "",
                  colorCode: "",
                  probability: "",
                  displayOrder: 1,
                  isActive: true,
                  max_wins_per_window: "",
                  cap_window_hours: "",
                  user_cooldown_hours: "",
                  min_spins_threshold: "",
                },
              ];
        companyspinwheelVoucher_.map((item) => {
          const colorCode = item?.colorCode ?? this.getRandomColor();
          item.colorCode = colorCode;
          item.probability = item?.probability ?? "";
          item.displayOrder = item?.displayOrder ?? "";
          item.isActive = item?.isActive ?? false;
          item.max_wins_per_window = item?.max_wins_per_window ?? '';
          item.cap_window_hours = item?.cap_window_hours ?? '';
          item.user_cooldown_hours = item?.user_cooldown_hours ?? '';
          item.min_spins_threshold = item?.min_spins_threshold ?? '';
          totalProbability += parseFloat(item.probability !== "" ? item.probability : 0);
          return item;
        });
        const companyspinwheelEarnType = result?.companyspinwheelEarnType ?? "";
        let companyspinwheelEarnType_ = { label: "Percentage", value: "P" };
        if (companyspinwheelEarnType !== "") {
          companyspinwheelEarnType_ = companyspinwheelEarnType === "P" ? { label: "Percentage", value: "P" } : { label: "Fixed", value: "F" };
        }
        this.setState({
          companyspinwheelEarnType: companyspinwheelEarnType_,
          companyspinwheelVoucher: companyspinwheelVoucher_,
          companySpineWheelEarnPercentage: companySpineWheelEarnPercentage,
          companySpineWheelClaimCount: companySpineWheelClaimCount,
          totalProbability: totalProbability,
          companyBonusType: result?.companyBonusType ?? "1",
        });
      });
    }
  }

  loadproductList() {
    this.setState({ pageloading: true });
    var urlShringTxt = `${apiUrl}products/dropdownlist?productType=7`;
    axios
      .get(urlShringTxt, clientheaderconfig)
      .then((res) => {
        if (res.data.status === "ok") {
          this.setState({ productList: res.data.result, pageloading: false }, function () {
            var tempVal = "";
            this.productListOption(tempVal);
          });
        }
      })
      .catch(() => {
        this.setState({ pageloading: false });
      });
  }

  productListOption = (selectedId) => {
    var productList = this.state.productList;
    let productLstHtml = "";
    if (selectedId !== "" && selectedId !== null && selectedId !== undefined) {
      productLstHtml = productList.map((productlst) => {
        if (selectedId === productlst._id) {
          return {
            value: productlst._id,
            label: productlst.label,
          };
        } else {
          return "";
        }
      });
      return productLstHtml !== "" ? productLstHtml : "";
    } else {
      productLstHtml = productList.map((productlst) => {
        return { value: productlst._id, label: productlst.label };
      });
      this.setState({ productListOptions: productLstHtml });
    }
  };

  sateValChange = (field, value) => {
    if (field === "page") {
    }
  };

  handleChange(checked, name) {
    this.setState({ checked });
  }

  /* signin - start*/
  fieldChange = (field, value, rowval) => {
    if (field === "companySpineWheelEarnPercentage") {
      const companySpineWheelEarnPercentage = this.state.companySpineWheelEarnPercentage;
      if (parseInt(value) > 100 && companySpineWheelEarnPercentage?.value === "P") {
        value = this.state.companySpineWheelEarnPercentage;
      }
      this.setState({ companySpineWheelEarnPercentage: value });
    } else if (field === "companyspinwheelEarnType") {
      this.setState({ companyspinwheelEarnType: value });
    } else if (field === "companySpineWheelClaimCount") {
      this.setState({ companySpineWheelClaimCount: value });
    } else {
      var companyspinwheelVoucher = this.state.companyspinwheelVoucher;
      if (field === "plus") {
        if (companyspinwheelVoucher.length < 8) {
          companyspinwheelVoucher.push({
            voucherID: "",
            voucherCustomName: "",
            colorCode: this.getRandomColor(),
            probability: "",
            displayOrder: companyspinwheelVoucher.length,
            isActive: true,
            max_wins_per_window: "",
            cap_window_hours: "",
            user_cooldown_hours: "",
            min_spins_threshold: "",
          });
        } else {
          showAlert("Error", "Maximum 8 Voucher only allowed", "error", "No");
        }
      } else if (field === "minus") {
        companyspinwheelVoucher.splice(rowval, 1);
      } else {
        companyspinwheelVoucher[rowval][field] = value;
      }
      let totalProbability = 0;
      companyspinwheelVoucher.forEach((item) => {
        totalProbability += parseFloat(item.probability !== "" ? item.probability : 0);
      });
      this.setState({ companyspinwheelVoucher, totalProbability });
    }
  };

  // Generate random hex color
  getRandomColor = () => {
    return (
      "#" +
      Math.floor(Math.random() * 16777215)
        .toString(16)
        .padStart(6, "0")
        .toUpperCase()
    );
  };

  handleSubmit = () => {
    let companyspinwheelVoucher_ = this.state.companyspinwheelVoucher;
    console.log(companyspinwheelVoucher_, "companyspinwheelVoucher_companyspinwheelVoucher_");
    let error = false;
    let totalVoucher = 0;
    if (companyspinwheelVoucher_.length > 0) {
      companyspinwheelVoucher_.map((item) => {
        var voucherID = item.voucherID?.value ?? "";
        if (voucherID === "") {
          error = true;
          item.voucherID_error = "This field is required";
        } else {
          item.voucherID_error = "";
          totalVoucher++;
        }
        return item;
      });
    } else {
      error = true;
    }
    if (error === false) {
      if (totalVoucher >= 4) {
        let updatespinwheelVoucher = [];
        companyspinwheelVoucher_.map((item) => {
          updatespinwheelVoucher.push({
            voucherID: item.voucherID,
            voucherCustomName: item.voucherCustomName,
            colorCode: item.colorCode,
            probability: item.probability,
            displayOrder: item.displayOrder,
            isActive: item.isActive,
            max_wins_per_window: item.max_wins_per_window,
            cap_window_hours: item.cap_window_hours,
            user_cooldown_hours: item.user_cooldown_hours,
            min_spins_threshold: item.min_spins_threshold,
          });
          return "";
        });
        showLoader("submit_frm", "class");
        var postObject = {
          companyspinwheelEarnType: this.state.companyspinwheelEarnType?.value ?? "P",
          companyspinwheelVoucher: JSON.stringify(updatespinwheelVoucher),
          companySpineWheelEarnPercentage: this.state.companySpineWheelEarnPercentage,
          companySpineWheelClaimCount: this.state.companySpineWheelClaimCount,
        };
        var post_url = `${module}/updateSetting`;
        const method = "update";
        this.props.getFormPost(postObject, post_url, "client", method);
      } else {
        showAlert("Error", "Minumum 4 Voucher required", "error", "No");
      }
    } else {
      this.setState({ companyspinwheelVoucher: companyspinwheelVoucher_ });
    }
  };

  render() {
    return (
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header {...this.props} currentPage={"spinwheel"} />
          <div className="layout-page">
            <Topmenu />
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row mb-3">
                  <div className="col-lg-10 col-md-6">
                    <h4 className="fw-bold">{moduleName}</h4>
                  </div>
                  <div className="col-lg-2 col-md-6 text-end"></div>
                </div>
                <div className="card">
                  <br />
                  <Tabs defaultValue="prizes" className="w-full">
                    <TabsList className="grid w-full grid-cols-3">
                      <TabsTrigger value="prizes">Prize Management</TabsTrigger>
                      <TabsTrigger value="probability" className="flex items-center gap-2">
                        <Activity className="h-4 w-4" />
                        Probability Audit
                      </TabsTrigger>
                      <TabsTrigger value="analytics" className="flex items-center gap-2">
                        <BarChart3 className="h-4 w-4" />
                        Analytics & Settings
                      </TabsTrigger>
                    </TabsList>

                    <TabsContent value="prizes" className="space-y-6 p-4">
                      <PostForm
                        {...this.props}
                        fields={this.state.clientdata}
                        onChange={this.fieldChange}
                        onValid={this.handleSubmit}
                        companyspinwheelEarnType={this.state.companyspinwheelEarnType}
                        companyspinwheelVoucher={this.state.companyspinwheelVoucher}
                        companySpineWheelEarnPercentage={this.state.companySpineWheelEarnPercentage}
                        companySpineWheelClaimCount={this.state.companySpineWheelClaimCount}
                        companyBonusType={this.state.companyBonusType}
                        totalProbability={this.state.totalProbability}
                        memberShipData={this.state.memberShipData}
                        productList={this.state.productList}
                        productListOptions={this.state.productListOptions}
                        productListOption={this.productListOption}
                        getRandomColor={this.getRandomColor.bind(this)}
                        onInvalid={() => {
                          setTimeout(function () {
                            if ($("#modulefrm .is-invalid").length > 0) {
                              $("html, body").animate(
                                {
                                  scrollTop: $(document).find("#modulefrm .is-invalid:first").offset().top - 100,
                                },
                                500,
                              );
                            }
                          }, 500);
                        }}
                      />

                      <div className="mt-8 p-4 bg-blue-50 rounded-lg">
                        <h3 className="font-semibold text-blue-900 mb-2">Tips:</h3>
                        <ul className="text-sm text-blue-800 space-y-1">
                          <li>• Active prize probabilities must sum to exactly 100%</li>
                          <li>• Use percentage field for discount amounts (0 for non-discount prizes)</li>
                          <li>• Display order determines wheel segment arrangement</li>
                          <li>• Inactive prizes won't appear on the wheel</li>
                          <li>• The intelligent probability system balances distribution over time</li>
                        </ul>
                      </div>
                    </TabsContent>

                    <TabsContent value="probability" className="p-4">
                      <ProbabilityAnalytics prizeData={this.state.companyspinwheelVoucher} />
                    </TabsContent>

                    <TabsContent value="analytics" className="p-4">
                      <Analytics />
                    </TabsContent>
                  </Tabs>
                </div>
              </div>
              <Footer />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle"></div>
        <div className="drag-target"></div>
        <PageLoader pageloading={this.state.pageloading} />
      </div>
    );
  }
}

const mapStateTopProps = (state) => {
  return {
    formpost: state.formpost,
    detaildata: state.detaildata,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getFormPost: (formPayload, postUrl, authType, method) => {
      dispatch({ type: GET_FORMPOST, formPayload, postUrl, authType, method });
    },
    getDetailData: (datas) => {
      dispatch({ type: GET_DETAILDATA, datas });
    },
  };
};

export default withRouter(connect(mapStateTopProps, mapDispatchToProps)(Form));

function validationConfig(props) {
  const { product_name } = props.fields;

  return {
    fields: ["product_name"],

    validations: {
      product_name: [[isEmpty, product_name]],
    },
  };
}

class PostForm extends Component {
  handleChange(name, value) {
    this.props.onChange(name, value);
  }
  handleChangeTierAct(name, incrt, value) {
    this.props.onChange(name, value, incrt);
  }
  handleChangeCheckbox(name, incrt, e) {
    const checked = e.target.checked;
    this.props.onChange(name, checked, incrt);
  }

  handlePlusMinusAct(actn, incrt) {
    this.props.onChange(actn, actn, incrt);
  }

  spinwheelRowView(fields, $field, onChange) {
    var productListOptions = this.props.productListOptions;
    var companyspinwheelVoucher = this.props.companyspinwheelVoucher;
    if (companyspinwheelVoucher !== undefined && companyspinwheelVoucher !== "" && Object.keys(companyspinwheelVoucher).length > 0) {
      var spinwheelRowCount = Object.keys(companyspinwheelVoucher).length;
      const spinwheelRowHtml = companyspinwheelVoucher.map((spinwheelRow, rwInt) => {
        let rwIntCnt = rwInt + 1;
        let voucherID = spinwheelRow?.voucherID ?? "";
        const voucherID_error = spinwheelRow?.voucherID_error ?? "";
        const colorCode = spinwheelRow?.colorCode ?? this.props.getRandomColor();
        return (
          <div className="row prize-card" key={rwInt}>
            <div class="prize-header">Prize #{rwIntCnt}</div>
            <div className={`col-md-3 reward_freeproduct_id ${voucherID_error !== "" ? "error-select" : ""}`}>
              <div className="form-floating form-floating-outline custm-select-box mb-4">
                <Select value={voucherID} placeholder={"Select Products"} onChange={this.handleChangeTierAct.bind(this, "voucherID", rwInt)} options={productListOptions} />
                <label className="select-box-label">Voucher</label>
                {voucherID_error !== "" && <span className="error">{voucherID_error}</span>}
              </div>
            </div>
            <div className="col-md-3">
              <div className="form-floating form-floating-outline mb-4">
                <input
                  type="text"
                  className="form-control"
                  name="voucherCustomName"
                  value={spinwheelRow?.voucherCustomName ?? ""}
                  {...$field("voucherCustomName", (e) => onChange("voucherCustomName", e.target.value, rwInt))}
                />
                <label htmlFor="voucherCustomName">Price Name</label>
              </div>
            </div>
            <div className="col-md-1">
              <div className="form-floating form-floating-outline mb-4">
                <input type="color" className="form-control" name="colorCode" value={colorCode ?? ""} {...$field("colorCode", (e) => onChange("colorCode", e.target.value, rwInt))} />
                <label htmlFor="colorCode">Price Color</label>
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-floating form-floating-outline mb-4">
                <input
                  type="text"
                  className="form-control"
                  name="probability"
                  value={spinwheelRow?.probability ?? ""}
                  {...$field("probability", (e) => onChange("probability", e.target.value, rwInt))}
                />
                <label htmlFor="probability">Probability (%)</label>
              </div>
            </div>
            <div className="col-md-2">
              <div className="form-floating form-floating-outline mb-4">
                <input
                  type="text"
                  className="form-control"
                  name="displayOrder"
                  value={spinwheelRow?.displayOrder ?? ""}
                  {...$field("displayOrder", (e) => onChange("displayOrder", e.target.value, rwInt))}
                />
                <label htmlFor="displayOrder">Display Order</label>
              </div>
            </div>
            <div className="col-md-1">
              {console.log(spinwheelRow?.isActive, "spinwheelRow?.isActive")}
              <div className="form-floating form-floating-outline mt-3">
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    id={`isActive${rwInt}`}
                    defaultChecked={spinwheelRow?.isActive ?? false}
                    onChange={this.handleChangeCheckbox.bind(this, "isActive", rwInt)}
                  />
                  <label class="form-check-label" for={`isActive${rwInt}`}>
                    {" "}
                    Active{" "}
                  </label>
                </div>
              </div>
            </div>
            <p className="text-xs font-medium text-muted-foreground mb-2">
                      Scarcity controls (leave empty for no limit)
                    </p>
            <div className="col-md-2">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="max_wins_per_window"
                value={spinwheelRow?.max_wins_per_window ?? ""}
                {...$field("max_wins_per_window", (e) => onChange("max_wins_per_window", e.target.value, rwInt))}
              />
              <label htmlFor="max_wins_per_window">Max wins per window</label>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="cap_window_hours"
                value={spinwheelRow?.cap_window_hours ?? ""}
                {...$field("cap_window_hours", (e) => onChange("cap_window_hours", e.target.value, rwInt))}
              />
              <label htmlFor="cap_window_hours">Window length (days)</label>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="user_cooldown_hours"
                value={spinwheelRow?.user_cooldown_hours ?? ""}
                {...$field("user_cooldown_hours", (e) => onChange("user_cooldown_hours", e.target.value, rwInt))}
              />
              <label htmlFor="user_cooldown_hours">Per-user cooldown (days)</label>
            </div>
          </div>
          <div className="col-md-3">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className="form-control"
                name="min_spins_threshold"
                value={spinwheelRow?.min_spins_threshold ?? ""}
                {...$field("min_spins_threshold", (e) => onChange("min_spins_threshold", e.target.value, rwInt))}
              />
              <label htmlFor="min_spins_threshold">Minimum total spins before eligible</label>
            </div>
          </div>
            {spinwheelRowCount.length >= 2 && (
              <div className="prize-card-remove" onClick={this.handlePlusMinusAct.bind(this, "minus", rwInt)}>
                <i className="fa fa-trash" aria-hidden="true"></i>
              </div>
            )}
          </div>
        );
      });

      return spinwheelRowHtml;
    } else {
      return "";
    }
  }

  render() {
    const { fields, onChange, onValid, onInvalid, $field } = this.props;

    return (
      <form className="fv-plugins-bootstrap5 reward-setting-maindiv" id="modulefrm">
        <div className="card-body row g-3 pt-5">
          {this.props.companyBonusType !== "5" && (
            <div className="col-md-2">
              <div className="form-floating form-floating-outline custm-select-box mb-4">
                <Select
                  value={this.props.companyspinwheelEarnType}
                  placeholder={"Select Earn Type"}
                  onChange={this.handleChange.bind(this, "companyspinwheelEarnType")}
                  options={[
                    { label: "Percentage", value: "P" },
                    { label: "Fixed", value: "F" },
                  ]}
                />
                <label className="select-box-label">Earn Type</label>
              </div>
            </div>
          )}
          <div className="col-md-3">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={"form-control"}
                name="companySpineWheelEarnPercentage"
                value={this.props.companySpineWheelEarnPercentage}
                {...$field("companySpineWheelEarnPercentage", (e) => onChange("companySpineWheelEarnPercentage", e.target.value))}
              />
              <label htmlFor="companySpineWheelEarnPercentage">
                {this.props.companyBonusType === "5" ? (
                  "Earn Per Visit"
                ) : (
                  <>
                    Earn {this.props.companyspinwheelEarnType?.value === "F" ? "Fixed" : "Percentage"}(1 point equal){this.props.companyspinwheelEarnType?.value === "F" ? "" : "%"}
                  </>
                )}
                <span className="error">*</span>
              </label>
            </div>
          </div>
          <div className="col-md-2">
            <div className="form-floating form-floating-outline mb-4">
              <input
                type="text"
                className={"form-control"}
                name="companySpineWheelClaimCount"
                value={this.props.companySpineWheelClaimCount}
                {...$field("companySpineWheelClaimCount", (e) => onChange("companySpineWheelClaimCount", e.target.value))}
              />
              <label htmlFor="companySpineWheelClaimCount">
                Point Per Spin<span className="error">*</span>
              </label>
            </div>
          </div>
          <div class="spinwheel-container">
            <div class="header">
              <div></div>
              <div class="actions">
                <span class="badge">Total Probability: {this.props.totalProbability}%</span>
                <button type="button" class="btn btn-dark" onClick={this.handlePlusMinusAct.bind(this, "plus", this.props.companyspinwheelVoucher.length - 1)}>
                  + Add Prize
                </button>
              </div>
            </div>
            {this.spinwheelRowView(fields, $field, onChange)}
            {this.props.companyspinwheelVoucher.length >= 2 && (
              <div class="header">
                <div></div>
                <div class="actions">
                  <span class="badge">Total Probability: {this.props.totalProbability}%</span>
                  <button type="button" class="btn btn-dark" onClick={this.handlePlusMinusAct.bind(this, "plus", this.props.companyspinwheelVoucher.length - 1)}>
                    + Add Prize
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        <div className="row g-3">
          <div className="pt-1 pb-4 pr-2 text-end" style={{ paddingRight: "20px" }}>
            <button
              type="button"
              className="btn btn-primary me-sm-3 me-1 waves-effect waves-light submit_frm"
              onClick={(e) => {
                e.preventDefault();
                this.props.$submit(onValid, onInvalid);
              }}
            >
              Save All Changes
            </button>
            <Link to={modulePath}>
              <button type="reset" className="btn btn-label-secondary waves-effect">
                Cancel
              </button>
            </Link>
          </div>
        </div>
      </form>
    );
  }
}
PostForm = validated(validationConfig)(PostForm);
